import { UI, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { CardTitle } from '../../../../components/CardTitle';
import { ColoredInfoSkeleton, InfoItem } from '../../../../components/InfoItem';
import { ProductCard } from '../../../../components/ProductCard';

export interface ValueAndConfirmationStepLoadingProps {
  productName: string;
}

export const ValueAndConfirmationStepLoading: React.FC<ValueAndConfirmationStepLoadingProps> = ({
  productName,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <ProductCard barColor="product.tesouro">
        <VStack space={Spacing['stack.xxxs']}>
          <CardTitle title={productName} />

          <InfoItem label="Vencimento" loading />
          <InfoItem label="Indexador" loading />
          <InfoItem label="Quantidade disponível" loading />
          <InfoItem label="Taxa de venda" loading />
          <InfoItem label="Preço Unitário" loading />

          <VStack space={Spacing['stack.quarck']} w="full">
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade desejada
            </UI.Text>

            <ColoredInfoSkeleton w="full" height="40px" />
          </VStack>

          <VStack space={Spacing['stack.quarck']} w="full">
            <UI.Text color="neutral.black" variant="semibold">
              Valor estimado
            </UI.Text>

            <ColoredInfoSkeleton w="full" height="40px" />
          </VStack>

          <UI.Text variant="semibold" color="neutral.black">
            Cliente confirmou o resgate
          </UI.Text>

          <VStack space={Spacing['stack.quarck']} w="full">
            <UI.Text color="neutral.darkest">Selecione o canal</UI.Text>
            <ColoredInfoSkeleton w="full" height="40px" />
          </VStack>

          <VStack space={Spacing['stack.quarck']} w="full">
            <UI.Text color="neutral.darkest">Observação</UI.Text>
            <ColoredInfoSkeleton w="full" height="120px" />
          </VStack>
        </VStack>
      </ProductCard>

      <HStack alignSelf="end" space={Spacing['inline.xxxs']}>
        <UI.Button variant="secondary" isDisabled>
          Cancelar
        </UI.Button>
        <UI.Button isDisabled>Confirmar</UI.Button>
      </HStack>
    </VStack>
  );
};
